export const formatDate = (date: string | number | Date) => {
  let d: Date;
  if (typeof date === "number") {
    d = new Date(date * 1000);
  } else {
    d = new Date(date);
  }
  const dia = d.toLocaleDateString("pt-BR", { day: "2-digit" });
  const mes = d.toLocaleDateString("pt-BR", { month: "2-digit" });
  const ano = d.toLocaleDateString("pt-BR", { year: "numeric" });
  const hora = d.toLocaleTimeString("pt-BR", {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  });
  return `${dia}/${mes}/${ano} às ${hora}`;
};
